export default __webpack_public_path__ + "d4999314cebf78c11f9820202efe877d.png";